import { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../../firebase';

// Call the Cloud Function that returns the public school directory.
// This avoids the Firestore permission issue where getDocs on /schools/ is
// denied for non-superadmin users (rules only allow reading your own school).
const functions = getFunctions(app, 'europe-west3');
const listSchoolsForRegistration = httpsCallable(functions, 'listSchoolsForRegistration');

export function useSchools() {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        setLoading(true);
        const result = await listSchoolsForRegistration();
        if (!isMounted) return;
        const items = (result.data?.schools ?? []);
        // Sort by name defensively on client side as well
        items.sort((a, b) =>
          String(a.schoolName || a.id).localeCompare(String(b.schoolName || b.id))
        );
        setSchools(items);
      } catch (e) {
        if (!isMounted) return;
        setError(e);
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    load();
    return () => { isMounted = false; };
  }, []);

  return { schools, loading, error };
}
